/* AmikoCrochet storefront refresh: shared behaviour (quick add on cards; opens Prestige's cart drawer). */
(function () {
  if (window.__akRefresh) { return; }
  window.__akRefresh = true;

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) { if (!response.ok) { throw new Error('add failed'); } return response.json(); });
  }
  function openDrawer(quantity, source) {
    /* A button that was redrawn while its add was running is no longer in the page; its event would never reach the theme. */
    (source && source.isConnected ? source : document).dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: quantity } }));
    if (!document.querySelector('#sidebar-cart, .Drawer--fromRight')) { window.location.href = '/cart'; }
  }
  /* Shared with the gift block further down (a separate closure): cart reads, adds and money display. */
  window.AmikoCart = { addItems: addItems, openDrawer: openDrawer, cartJson: cartJson, formatCents: formatCents, setMoney: setMoney };

  /* Product gallery: a thumbnail shows its picture as the large one (desktop), or moves the swipe slider to it
     (phones and tablets, where Prestige's Flickity slider is active); a swipe marks the matching thumbnail. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ak-thumbs]'), function (row) {
    var gallery = row.closest('.Product__Gallery');
    if (!gallery) { return; }
    var slideshow = gallery.querySelector('.Product__Slideshow');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.Product__SlideItem'));
    if (!gallery.querySelector('.Product__SlideItem.ak-is-shown')) {
      var first = gallery.querySelector('.Product__SlideItem');
      var firstThumb = row.querySelector('[data-ak-thumb]');
      if (first) { first.classList.add('ak-is-shown'); }
      if (firstThumb) { firstThumb.classList.add('is-active'); firstThumb.setAttribute('aria-pressed', 'true'); }
    }
    function slider() {
      var flkty = slideshow && window.Flickity && window.Flickity.data ? window.Flickity.data(slideshow) : null;
      return flkty && flkty.isActive ? flkty : null;
    }
    function mark(id) {
      var active = null;
      slides.forEach(function (slide) { slide.classList.toggle('ak-is-shown', slide.getAttribute('data-image-id') === id); });
      Array.prototype.forEach.call(row.querySelectorAll('[data-ak-thumb]'), function (thumb) {
        var on = thumb.getAttribute('data-ak-thumb') === id;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) { active = thumb; }
      });
      /* More thumbnails than fit: bring the marked one into the row's view (sideways only, never the page). */
      if (active && row.scrollWidth > row.clientWidth) {
        row.scrollTo({ left: active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
    row.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ak-thumb]');
      if (!button) { return; }
      var id = button.getAttribute('data-ak-thumb');
      mark(id);
      var flkty = slider();
      if (flkty) {
        var index = -1;
        slides.forEach(function (slide, i) { if (slide.getAttribute('data-image-id') === id) { index = i; } });
        if (index !== -1) { flkty.select(index); }
      }
      if (window.lazySizes && window.lazySizes.loader) { window.lazySizes.loader.checkElems(); }
    });
    /* Flickity marks the shown slide with is-selected, whenever the slider was built and however it moved. */
    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        if (!slider()) { return; }
        var selected = gallery.querySelector('.Product__SlideItem.is-selected');
        var id = selected && selected.getAttribute('data-image-id');
        var current = row.querySelector('[data-ak-thumb].is-active');
        if (id && (!current || current.getAttribute('data-ak-thumb') !== id)) { mark(id); }
      });
      slides.forEach(function (slide) { observer.observe(slide, { attributes: true, attributeFilter: ['class'] }); });
    }
  });

  /* Offer (owner decision 2026-10-12): one pattern, the 3-Pattern Bundle (cart tier 3+ = 33%: $13.99) or Buy 3, Get 3
     FREE (6+ = 50%: $20.88).
     Every pattern is one PDF with one download link, so a pattern is never added twice: a second copy would count
     toward the multi-pattern discount but deliver the same single file. */
  function cartJson() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function addMissing(ids, properties) {
    return cartJson().then(function (cart) {
      var have = {};
      cart.items.forEach(function (i) { have[String(i.variant_id)] = 1; });
      var items = [];
      ids.forEach(function (id) {
        id = String(id);
        if (have[id]) { return; }
        have[id] = 1;
        var item = { id: Number(id), quantity: 1 };
        if (properties) { item.properties = properties; }
        items.push(item);
      });
      return items.length ? addItems(items).then(function () { return items.length; }) : 0;
    });
  }
  function formatCents(cents) {
    var amount = (cents / 100).toFixed(2), format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return format.replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      if (key === 'amount_no_decimals') { return String(Math.round(cents / 100)); }
      if (key.indexOf('comma') !== -1) { return amount.replace('.', ','); }
      return amount;
    });
  }
  /* The currency app (Bucks) converts .money once and keeps the USD value in bucks-* attributes. A price rewritten here
     is USD again, so its marks are cleared and the app converts it anew (otherwise "Pick any 3" showed $ next to dh). */
  var reconvertTimer;
  function reconvert() {
    clearTimeout(reconvertTimer);
    reconvertTimer = setTimeout(function () {
      try { if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') { window.bucksCC.reConvert(); } } catch (e) { /* display only */ }
    }, 0);
  }
  function setMoney(node, text) {
    if (!node) { return; }
    var money = node.querySelector('.money') || node;
    var converted = money.hasAttribute('bucks-original');
    if ((converted ? money.getAttribute('bucks-original') : money.textContent) === text) { return; }
    money.textContent = text;
    if (converted) {
      money.classList.remove('buckscc-converted', 'buckscc-money');
      ['bucks-original', 'bucks-init', 'bucks-currency', 'bucks-current'].forEach(function (name) { money.removeAttribute(name); });
      reconvert();
    }
  }

  /* Checklist 3.3: the page preview (Product landing > Page preview block). The page loads from one small script per
     product (assets/tb-page-preview-<handle>.js) when the card nears the screen or is tapped; it fills the blurred peek
     and the sharp page in the modal. The theme opens the modal itself and stops the click there, so the click listener
     runs in the capture phase. */
  function akPage(handle, src) {
    function show(url) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-ak-page-img], [data-ak-peek-img]'), function (img) {
        if (!img.getAttribute('src')) { img.setAttribute('src', url); }
      });
    }
    var all = window.tbPagePreview || {};
    if (all[handle]) { show(all[handle]); return; }
    var script = document.querySelector('script[data-ak-page]');
    if (!script) {
      script = document.createElement('script');
      script.src = src;
      script.setAttribute('data-ak-page', handle);
      document.head.appendChild(script);
    }
    script.addEventListener('load', function () { var url = (window.tbPagePreview || {})[handle]; if (url) { show(url); } });
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ak-page-src]');
    if (trigger) { akPage(trigger.getAttribute('data-ak-page-handle'), trigger.getAttribute('data-ak-page-src')); }
  }, true);
  var akPeek = document.querySelector('.ak-peek__page[data-ak-page-src]');
  if (akPeek) {
    var akPeekLoad = function () { akPage(akPeek.getAttribute('data-ak-page-handle'), akPeek.getAttribute('data-ak-page-src')); };
    if ('IntersectionObserver' in window) {
      var akPeekSeen = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { akPeekSeen.disconnect(); akPeekLoad(); }
      }, { rootMargin: '400px 0px' });
      akPeekSeen.observe(akPeek);
    } else { akPeekLoad(); }
  }

  /* The buy button under the FAQ presses the main Add to cart, so it adds whatever is chosen (checklist 3.5). */
  document.addEventListener('click', function (event) {
    var again = event.target.closest('[data-ak-buy-again]');
    if (!again) { return; }
    var main = document.querySelector('.ProductForm__AddToCart');
    if (main && !main.disabled) { main.click(); }
  });

  /* Set cards (Pattern sets page, homepage): their own button adds the set. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ak-bundle]'), function (block) {
    var button = block.querySelector('[data-ak-bundle-add]'), input = block.querySelector('[data-ak-bundle-ids]');
    if (!button || !input) { return; }
    var label = button.textContent;
    button.addEventListener('click', function () {
      button.disabled = true;
      /* 1 / 4 / 7 offer set cards also carry their free gifts (filled by the gift block) and their discount code. */
      var gifts = (input.getAttribute('data-ak-gifts') || '').split(',').filter(Boolean), code = input.getAttribute('data-ak-code');
      addMissing(input.getAttribute('data-ak-bundle-ids').split(','), { _bundle: input.getAttribute('data-ak-bundle-name') })
        .then(function (added) { return gifts.length ? addMissing(gifts, { _gift: 'Free gift' }).then(function (more) { return added + more; }) : added; })
        .then(function (added) {
          if (!code) { return added; }
          return fetch('/cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: code })
          }).then(function () { return added; }, function () { return added; });
        })
        .then(function (added) { openDrawer(added, button); })
        .catch(function () { button.textContent = 'Please try again'; })
        .then(function () { button.disabled = false; setTimeout(function () { button.textContent = label; }, 1800); });
    });
  });

  /* Product page chooser: the default is the product section's "Chosen when the page opens" setting; the one Add to cart button adds whatever is chosen.
     Every option carries its own variant ids (data-ak-ids): the patterns are fixed, nothing to pick. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ak-choose]'), function (box) {
    var form = box.closest('form');
    var button = form && form.querySelector('.ProductForm__AddToCart');
    if (!button) { return; }
    box.hidden = false;
    var sticky = document.querySelector('[data-amiko-sticky]');
    var stickyButton = sticky && sticky.querySelector('[data-amiko-sticky-add]');
    var stickyLabel = stickyButton && stickyButton.textContent;
    function chosen() { return box.querySelector('input[type="radio"]:checked'); }
    function sync() {
      var input = chosen(), mode = input.value;
      Array.prototype.forEach.call(box.querySelectorAll('.ak-choose__opt'), function (opt) { opt.classList.toggle('is-chosen', opt.contains(input)); });
      var price = input.getAttribute('data-ak-price'), label = input.getAttribute('data-ak-label');
      var parts = button.querySelectorAll(':scope > span');
      if (parts.length >= 3) { parts[0].textContent = label; parts[parts.length - 1].textContent = price; }
      /* The buy button under the FAQ (checklist 3.5) says the same as the main one. */
      Array.prototype.forEach.call(document.querySelectorAll('[data-ak-buy-again]'), function (again) {
        var l = again.querySelector('[data-ak-again-label]'), p = again.querySelector('[data-ak-again-price]');
        if (l && !again.hasAttribute('data-ak-again-fixed')) { l.textContent = label; }  /* a Theme Editor label stays */
        if (p) { p.textContent = price; }
      });
      /* "Buy it now" always buys one pattern, so it only shows with "Just this pattern". Add to cart is always the
         filled main button; the express button sits below it (2026-10-09). */
      var payments = form.querySelectorAll('.shopify-payment-button');
      Array.prototype.forEach.call(payments, function (node) { node.style.display = mode === 'single' ? '' : 'none'; });
      button.classList.add('Button--primary');
      button.classList.remove('Button--secondary');
      if (sticky) {
        Array.prototype.forEach.call(sticky.querySelectorAll('[data-pl-price]'), function (node) { setMoney(node, price); });
        var was = sticky.querySelector('[data-ak-sticky-was]'), wasPrice = input.getAttribute('data-ak-was');
        if (was) { was.hidden = !wasPrice; if (wasPrice) { setMoney(was, wasPrice); } }
        if (stickyButton) { stickyButton.textContent = mode === 'single' ? stickyLabel : label; }
      }
    }
    box.addEventListener('change', function (event) { if (event.target.type === 'radio') { sync(); } });
    /* "Only ... more for 3 more patterns" chooses the bigger bundle (data-ak-pick names the option). */
    box.addEventListener('click', function (event) {
      var pick = event.target.closest('[data-ak-pick]');
      if (!pick) { return; }
      event.preventDefault();
      var input = box.querySelector('input[type="radio"][value="' + pick.getAttribute('data-ak-pick') + '"]');
      if (input) { input.checked = true; sync(); input.focus(); }
    });
    sync();
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (button.disabled) { return; }
      var input = chosen(), name = input.getAttribute('data-ak-name');
      var ids = input.getAttribute('data-ak-ids').split(','), properties = name ? { _bundle: name } : null;
      button.disabled = true;
      /* 1 / 4 / 7 offer: the card's free gift(s) go in as their own $0.00 lines, then the card's discount code. */
      var gifts = (input.getAttribute('data-ak-gifts') || '').split(',').filter(Boolean), code = input.getAttribute('data-ak-code');
      addMissing(ids, properties)
        .then(function (added) { return gifts.length ? addMissing(gifts, { _gift: 'Free gift' }).then(function (more) { return added + more; }) : added; })
        .then(function (added) {
          if (!code) { return added; }
          return fetch('/cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: code })
          }).then(function () { return added; }, function () { return added; });
        })
        .then(function (added) { openDrawer(added, button); })
        .catch(function () { var parts = button.querySelectorAll(':scope > span'); if (parts[0]) { parts[0].textContent = 'Please try again'; } })
        .then(function () { button.disabled = false; setTimeout(sync, 1800); });
    });
  });

  /* Cart "next step" card (owner-approved 2026-10-09, ladder 2026-10-12): one next rung, its real new total, one button.
     1–2 patterns: make it 3 (3-Pattern Bundle). 3–5 patterns: make it 6 (Buy 3, Get 3 FREE). 6+: the saving line.
     Totals are predicted with the live tiers (AmikoRelated.offers) and Shopify's rounding (saving rounded down to the
     cent); when the cart's applied discount disagrees with that prediction, the card drops the prices. */
  var cfg = window.AmikoRelated;
  var productCache = {};
  function productJs(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { if (!r.ok) { throw new Error(); } return r.json(); });
    }
    return productCache[handle];
  }
  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) { node.className = cls; }
    if (text != null) { node.textContent = text; }
    return node;
  }
  var Next = {
    tiers: function (o) { return [[2, o.pair_percent || 0], [3, o.trio_percent], [o.six_count, o.six_percent]]; },
    percent: function (n, o) { var p = 0; Next.tiers(o).forEach(function (t) { if (n >= t[0]) { p = t[1]; } }); return p; },
    total: function (original, n, o) { return original - Math.floor(original * Next.percent(n, o) / 100); },
    applied: function (cart) {
      var a = (cart.cart_level_discount_applications || []).filter(function (x) { return x.value_type === 'percentage'; })[0];
      return a ? Math.round(parseFloat(a.value)) : 0;
    },
    /* Which rung comes next, and which patterns get it there (handles, best first). */
    plan: function (cart, c) {
      /* The 1 / 4 / 7 offer on every product (owner 2026-10-31) replaced the 3 / 6 ladder: with the weekly gifts on the
         page (window.AmikoGifts) no cart gets the old card, which would advertise the 3+ / 6+ discounts. A cart with the
         1 / 4 / 7 offer (a gift line or a 4 / 7 bundle) never gets it either. */
      if (window.AmikoGifts) { return null; }
      if (cart.items.some(function (i) { var pr = i.properties || {}; return pr._gift || /^buy [47] /.test(pr._bundle || ''); })) { return null; }
      var o = c.offers, handles = [], seen = {};
      cart.items.forEach(function (i) { if (!seen[i.handle]) { seen[i.handle] = 1; handles.push(i.handle); } });
      var n = handles.length;
      if (!n) { return null; }
      /* The set most of the cart belongs to; on a tie, the one with fewer patterns left to add. */
      var best = null, bestCount = 0, bestLeft = 0;
      Object.keys(c.sets).forEach(function (k) {
        var count = c.sets[k].handles.filter(function (m) { return seen[m]; }).length, left = c.sets[k].handles.length - count;
        if (count > bestCount || (count === bestCount && count > 0 && left < bestLeft)) { best = k; bestCount = count; bestLeft = left; }
      });
      var rest = best ? c.sets[best].handles.filter(function (m) { return !seen[m]; }) : [];
      function suggest(count) {
        var picks = [];
        function take(h) { if (!seen[h] && picks.indexOf(h) === -1) { picks.push(h); } }
        handles.forEach(function (h) { (c.related[h] || []).forEach(take); });
        rest.forEach(take);
        return picks.slice(0, count);
      }
      if (n < 3) { return { kind: 'three', n: n, set: best, picks: suggest(3 - n) }; }
      if (n < o.six_count) { return { kind: 'six', n: n, set: best, picks: suggest(o.six_count - n) }; }
      return { kind: 'done', n: n, set: best, picks: [] };
    },
    /* Words for the card. money(cents) formats; prices are left out when trusted is false. */
    words: function (plan, cart, added, c, money, trusted) {
      var o = c.offers, n = plan.n, k = added.length;
      var pct = function (p) { return p + '% off'; };
      var onAll = function (p, count) { return p + ' all ' + count; };
      var cap = function (t) { return t.charAt(0).toUpperCase() + t.slice(1); };
      if (plan.kind === 'done' || !k) {
        var now = Next.percent(n, o);
        return now ? { head: cap(onAll(pct(now), n)) + ' patterns.', sub: '' } : null;
      }
      var newN = n + k, original = cart.original_total_price;
      added.forEach(function (p) { original += p.price; });
      var total = Next.total(original, newN, o), delta = total - cart.total_price, p = pct(Next.percent(newN, o));
      var change = delta > 0 ? 'only ' + money(delta) + ' more' : (delta === 0 ? 'for no extra cost' : 'and your total goes down ' + money(-delta));
      var names = added.map(function (a) { return a.title; });
      var out = { names: names };
      if (plan.kind === 'six') {
        out.head = trusted ? 'Buy 3, Get 3 FREE: 6 for ' + money(total) : 'Buy 3, Get 3 FREE';
        out.sub = trusted ? 'Add ' + k + ' more: ' + newN + ' patterns, ' + change + '.' : 'Add ' + k + ' more and get ' + p + ' on all ' + newN + '.';
        out.button = k === 1 ? 'Add ' + names[0] : (k === 2 ? 'Add both' : 'Add these ' + k);
      } else {
        out.head = trusted ? 'Make it ' + newN + ' for ' + money(total) : 'Make it ' + newN + ': ' + onAll(p, newN);
        out.sub = trusted ? (delta === 0 && newN === 3 ? 'Your 3rd pattern is free.' : (delta < 0 ? 'Your total goes down ' + money(-delta) + ': ' + onAll(p, newN) + '.' : cap(onAll(p, newN)) + ', ' + change + '.')) : '';
        out.button = k === 1 ? 'Add ' + names[0] : (k === 2 ? 'Add both' : 'Add these ' + k);
      }
      return out;
    }
  };
  window.AmikoNext = Next;

  function buildNudge(cart) {
    if (!cfg || !cfg.sets || !cart.items.length) { return Promise.resolve(null); }
    var plan = Next.plan(cart, cfg);
    if (!plan) { return Promise.resolve(null); }
    var n = plan.n, trusted = Next.applied(cart) === Next.percent(n, cfg.offers) && cart.total_price === Next.total(cart.original_total_price, n, cfg.offers);
    return Promise.all(plan.picks.map(function (h) { return productJs(h).catch(function () { return null; }); })).then(function (products) {
      var added = products.filter(function (p) { return p && p.available; }).map(function (p) {
        return { id: p.variants[0].id, price: p.variants[0].price, title: (cfg.short_titles && cfg.short_titles[p.handle]) || p.title.replace(' (PDF)', '').replace(' Crochet Pattern', ''), image: p.featured_image };
      });
      if (plan.kind !== 'done' && added.length < plan.picks.length) { added = []; }
      var text = Next.words(plan, cart, added, cfg, formatCents, trusted);
      if (!text) { return null; }
      var box = el('div', 'ak-next' + (added.length ? '' : ' ak-next--done'));
      box.setAttribute('data-ak-nudge', ''); box.setAttribute('aria-live', 'polite');
      box.appendChild(el('p', 'ak-next__head', text.head));
      if (text.sub) {
        /* The money part of the line ("only $3.48 more", "Your 3rd pattern is free") is the value: shown in bold. */
        var sub = el('p', 'ak-next__sub'), m = text.sub.match(/(only \S+ more|for no extra cost|your total goes down \S+|Your 3rd pattern is free)/i);
        if (m) {
          sub.appendChild(document.createTextNode(text.sub.slice(0, m.index)));
          sub.appendChild(el('strong', '', m[0]));
          sub.appendChild(document.createTextNode(text.sub.slice(m.index + m[0].length)));
        } else { sub.textContent = text.sub; }
        box.appendChild(sub);
      }
      if (added.length) {
        /* Up to 3 suggestions: one tile each (picture + name). 4-5 (completing a set): a row of pictures + the names line. */
        var tiles = added.length <= 3, shown = added.slice(0, 5);
        var row = el('ul', 'ak-next__items' + (tiles ? ' ak-next__items--tiles ak-next__items--n' + shown.length : ''));
        shown.forEach(function (a) {
          var li = el('li', 'ak-next__item');
          if (a.image) {
            var img = el('img'); img.src = a.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2'); img.alt = tiles ? '' : a.title;
            img.width = tiles ? 72 : 52; img.height = img.width;
            li.appendChild(img);
          }
          if (tiles) { li.appendChild(el('span', 'ak-next__name', a.title)); }
          row.appendChild(li);
        });
        box.appendChild(row);
        if (!tiles) {
          var names = text.names.slice(0, 2).join(', ') + ' + ' + (text.names.length - 2) + ' more';
          box.appendChild(el('p', 'ak-next__names', names));
        }
        var button = el('button', 'Button Button--primary Button--full ak-next__add', text.button);
        button.type = 'button';
        button.setAttribute('data-ak-next-add', added.map(function (a) { return a.id; }).join(','));
        button.setAttribute('data-ak-next-kind', plan.kind);
        box.appendChild(button);
        if (plan.kind !== 'set' && plan.set && cfg.sets[plan.set].collection) {
          var link = el('a', 'ak-next__own', 'Or choose your own ' + cfg.sets[plan.set].title.replace(' Set', '') + ' patterns');
          link.href = cfg.sets[plan.set].collection;
          box.appendChild(link);
        }
      }
      return box;
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ak-next-add]');
    if (!button || button.disabled) { return; }
    event.preventDefault();
    var label = button.textContent;
    button.disabled = true; button.textContent = 'Adding…';
    if (window.clarity) { window.clarity('event', 'ak_cart_next_' + button.getAttribute('data-ak-next-kind')); }
    addMissing(button.getAttribute('data-ak-next-add').split(','))
      .then(function (added) { openDrawer(added, button); })
      .catch(function () { button.disabled = false; button.textContent = 'Please try again'; setTimeout(function () { button.textContent = label; }, 1800); });
  });
  /* A line with more than one copy (added before this change, or from another page) is set back to one copy. */
  function oneCopyEach(cart) {
    var extra = cart.items.filter(function (i) { return i.quantity > 1; });
    if (!extra.length) { return Promise.resolve(cart); }
    return extra.reduce(function (chain, item) {
      return chain.then(function () {
        return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 1 }) });
      });
    }, Promise.resolve()).then(function () {
      if (document.querySelector('form.Cart--expanded')) { window.location.reload(); }
      else { document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: 0 } })); }
      return null;
    });
  }
  /* One card build at a time; a request that arrives during a build (the drawer redrawing after an add) runs right
     after it, so the card always ends up built from the latest cart. */
  var nudgeBusy = false, nudgeAgain = false, redrawAsked = false;
  /* Prestige skips a drawer refresh that arrives while another is loading, so a fast tap can leave the drawer showing
     fewer patterns than the cart holds. Ask for one more redraw when the counts differ. */
  function drawerInStep(cart) {
    var drawerLines = document.querySelectorAll('#sidebar-cart .CartItem').length;
    if (!document.querySelector('#sidebar-cart .Drawer__Main') || drawerLines === cart.items.length) { redrawAsked = false; return; }
    if (redrawAsked) { return; }
    redrawAsked = true;
    setTimeout(function () { document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: 0 } })); }, 400);
  }
  function placeNudge() {
    if (nudgeBusy) { nudgeAgain = true; return; }
    var drawerMain = document.querySelector('#sidebar-cart .Drawer__Main');
    var page = document.querySelector('form.Cart--expanded');
    if (!drawerMain && !page) { return; }
    nudgeBusy = true;
    cartJson().then(oneCopyEach).then(function (cart) { if (cart) { drawerInStep(cart); } return cart && buildNudge(cart); }).then(function (box) {
      [drawerMain, page].forEach(function (host) {
        if (!host || !document.contains(host)) { return; }
        var old = host.querySelector('[data-ak-nudge]'); if (old) { old.remove(); }
        if (!box) { return; }
        var node = box.cloneNode(true);
        if (host === drawerMain) { var wrap = document.createElement('div'); wrap.className = 'Drawer__Container'; wrap.setAttribute('data-ak-nudge', ''); wrap.appendChild(node); node.removeAttribute('data-ak-nudge'); host.insertBefore(wrap, host.firstChild); }
        else { host.insertBefore(node, host.firstChild); }
      });
    }).catch(function () {}).then(function () {
      setTimeout(function () {
        nudgeBusy = false;
        /* The drawer may have been redrawn (new host) during the build: build again for the current drawer. */
        var current = document.querySelector('#sidebar-cart .Drawer__Main');
        if (nudgeAgain || (current && current !== drawerMain)) { nudgeAgain = false; placeNudge(); }
      }, 300);
    });
  }
  var drawer = document.getElementById('sidebar-cart');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () { if (!drawer.querySelector('[data-ak-nudge]')) { placeNudge(); } }).observe(drawer, { childList: true, subtree: true });
  }
  document.addEventListener('product:added', function () { setTimeout(placeNudge, 900); });
  placeNudge();

  /* Prestige places the desktop info column absolutely, sized to the gallery. When the buy box is taller than a short
     gallery it ran over the trust strip below; grow the wrapper to the info column's height instead. */
  var productWrapper = document.querySelector('.Product__Wrapper'), productInfo = document.querySelector('.Product__Info');
  function fitProduct() {
    if (!productWrapper || !productInfo) { return; }
    productWrapper.style.minHeight = '';
    if (window.matchMedia('(min-width: 1008px)').matches && productInfo.offsetHeight > productWrapper.offsetHeight) {
      productWrapper.style.minHeight = productInfo.offsetHeight + 'px';
    }
  }
  if (productWrapper && productInfo) {
    fitProduct();
    window.addEventListener('resize', fitProduct);
    window.addEventListener('load', fitProduct);
    if (window.ResizeObserver) { new ResizeObserver(fitProduct).observe(productInfo); }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ak-quick-add]');
    if (!button || button.disabled) { return; }
    event.preventDefault();
    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    addMissing([button.getAttribute('data-ak-quick-add')])
      .then(function (added) { button.textContent = 'Added'; openDrawer(added, button); })
      .catch(function () { button.textContent = 'Try again'; })
      .then(function () { setTimeout(function () { button.disabled = false; button.textContent = label; }, 1800); });
  });

  /* M10 collection toolbar: Prestige reloads only the product grid on sort, so keep "Sort: <current>" in step. */
  document.addEventListener('click', function (event) {
    var option = event.target.closest('#collection-sort-popover .Popover__Value');
    var value = document.querySelector('.ak-toolbar__sort-value');
    if (option && value) { value.textContent = ': ' + option.textContent.trim(); }
  });
})();

// Footer "Your privacy choices": opens Shopify's cookie preferences where the banner runs, else follows the link to
// the US opt-out page.
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-ak-privacy-choices]');
    if (link && window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      event.preventDefault();
      window.privacyBanner.showPreferences();
    }
  });

  /* 1 / 4 / 7 offer, this week's free gift (owner 2026-10-31). window.AmikoGifts (snippets/amiko-gifts-json, on every
     page) lists the rotation by handle. A week ends Sunday 23:59 store time (cfg.tz); then the next gift starts,
     repeating after the last one. The 4 card gets this week's gift, the 7 card also the second one (cfg.second, else
     next week's gift). The timer gives each visitor 3 hours from their first visit (owner 2026-11-01; kept in
     localStorage, not tied to the week's end) and starts a new 3 hours when they run out. At the change the
     cards and the cart switch to the new gift: a cart holding last week's gift gets this week's instead (on the cart page it reloads once to show it). The
     delivery Worker sends only the gifts of the order's week. */
  (function () {
    var cfg = window.AmikoGifts, C = window.AmikoCart;
    if (!cfg || !cfg.weeks || !cfg.weeks.length || !C || !C.cartJson) { return; }
    var giftCache = {};
    function giftProduct(handle) {
      if (!giftCache[handle]) {
        giftCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) { throw new Error('gift ' + handle); } return r.json(); });
      }
      return giftCache[handle];
    }
    var WEEK = 604800000, a = cfg.anchor || [2026, 10, 25, 23, 59];
    var anchorWall = Date.UTC(a[0], a[1] - 1, a[2], a[3], a[4]);
    var fmt = null;
    try {
      fmt = new Intl.DateTimeFormat('en-US', { timeZone: cfg.tz, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });
    } catch (e) { fmt = null; }
    /* The store's wall-clock time of an instant, as if it were UTC (so week arithmetic ignores daylight changes). */
    function wall(ms) {
      if (!fmt) { return ms + 3600000; }
      var o = {};
      fmt.formatToParts(new Date(ms)).forEach(function (part) { o[part.type] = part.value; });
      return Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute, +o.second);
    }
    function week(now) {
      var w = wall(now), idx = Math.floor((w - anchorWall) / WEEK), endWall = anchorWall + (idx + 1) * WEEK;
      var end = endWall - (w - now);
      end = endWall - (wall(end) - end);
      return { idx: idx, end: end };
    }
    function at(list, i) { var n = list.length; return list[((i % n) + n) % n]; }
    function handles(idx) {
      var current = at(cfg.weeks, idx), second = cfg.second || (cfg.weeks.length > 1 ? at(cfg.weeks, idx + 1) : '');
      return { current: current, second: second && second !== current ? second : '', changes: at(cfg.weeks, idx + 1) !== current };
    }
    function sized(url) { return url ? url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=80&height=80&crop=center' : ''; }
    function gift(handle) {
      if (!handle) { return Promise.resolve(null); }
      return giftProduct(handle).then(function (product) {
        var v = (product.variants || []).filter(function (x) { return x.available; })[0];
        return v ? { variant: v.id, title: String(product.title).replace(/^Free gift:\s*/i, ''), image: product.featured_image, price: v.price, compareAt: v.compare_at_price || 0 } : null;
      }, function () { return null; });
    }

    function fill(g) {
      Array.prototype.forEach.call(document.querySelectorAll('.ak-offer[data-ak-choose], [data-ak-bundle]'), function (box) {
        Array.prototype.forEach.call(box.querySelectorAll('[data-ak-gift-slot]'), function (slot) {
          var item = slot.getAttribute('data-ak-gift-slot') === 'second' ? g.second : g.current;
          slot.hidden = !item;
          if (!item) { return; }
          var img = slot.querySelector('[data-ak-gift-img]'), name = slot.querySelector('[data-ak-gift-name]'), was = slot.querySelector('[data-ak-gift-was]');
          if (img && item.image) { img.src = sized(item.image); }
          if (name) { name.textContent = item.title; }
          if (was) { was.hidden = !(item.compareAt > item.price); if (!was.hidden) { C.setMoney(was, C.formatCents(item.compareAt)); } }
        });
        Array.prototype.forEach.call(box.querySelectorAll('input[data-ak-gift-count]'), function (input) {
          var ids = [];
          if (g.current) { ids.push(g.current.variant); }
          if (input.getAttribute('data-ak-gift-count') === '2' && g.second) { ids.push(g.second.variant); }
          input.setAttribute('data-ak-gifts', ids.join(','));
        });
      });
    }

    /* A cart's gift lines (property _gift) become this week's: a cart with one keeps this week's gift, a cart with two
       this week's and the second; any other gift line (last week's, a copy) is removed. */
    function fixCart(g) {
      return C.cartJson().then(function (cart) {
        var lines = cart.items.filter(function (i) { return i.properties && i.properties._gift; });
        if (!lines.length || !g.current) { return false; }
        var want = [g.current, g.second].filter(Boolean).slice(0, Math.min(lines.length, 2)), kept = {}, updates = {}, add = [];
        lines.forEach(function (line) {
          var wanted = want.some(function (w) { return w.variant === line.variant_id; });
          if (wanted && !kept[line.variant_id]) {
            kept[line.variant_id] = 1;
            if (line.quantity !== 1) { updates[line.key] = 1; }
          } else {
            updates[line.key] = 0;
          }
        });
        want.forEach(function (w) { if (!kept[w.variant]) { add.push({ id: w.variant, quantity: 1, properties: { _gift: 'Free gift' } }); } });
        if (!Object.keys(updates).length && !add.length) { return false; }
        var step = Object.keys(updates).length ? fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }) : Promise.resolve();
        return step.then(function () { return add.length ? C.addItems(add) : null; }).then(function () { return true; });
      }).then(function (changed) {
        if (!changed || !/^\/cart\/?$/.test(window.location.pathname)) { return; }
        try { if (sessionStorage.getItem('akGiftFix') === String(state.idx)) { return; } sessionStorage.setItem('akGiftFix', String(state.idx)); } catch (e) { return; }
        window.location.reload();
      }, function () { /* the Worker still sends only this week's gifts */ });
    }

    var box = document.querySelector('[data-ak-countdown]'), mini = box && document.querySelector('[data-ak-countdown-mini]');
    var outs = [box && box.querySelector('[data-ak-countdown-time]'), mini && mini.querySelector('[data-ak-countdown-time]')].filter(Boolean);
    var state = week(Date.now()), timerOn = false;
    /* Each visitor's own 3-hour window, set on their first visit and started again when it runs out (owner 2026-11-01). */
    var VISIT = 3 * 3600000, visitEnd = 0;
    try { visitEnd = +localStorage.getItem('akGiftTimerEnd') || 0; } catch (e) { visitEnd = 0; }
    function newWindow() {
      var now = Date.now();
      if (visitEnd > now && visitEnd <= now + VISIT) { return; }
      visitEnd = now + VISIT;
      try { localStorage.setItem('akGiftTimerEnd', String(visitEnd)); } catch (e) { /* this page only */ }
    }
    newWindow();
    function showTimer(on) {
      timerOn = on;
      if (box) { box.hidden = !on; }
      if (mini) { mini.hidden = !on; }
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var now = Date.now();
      if (now >= state.end) { load(); return; }
      if (now >= visitEnd) { newWindow(); }
      var s = Math.max(0, Math.floor((visitEnd - now) / 1000)), d = Math.floor(s / 86400);
      var text = (d ? d + 'd ' : '') + pad(Math.floor(s % 86400 / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      outs.forEach(function (o) { o.textContent = text; });
    }
    function load() {
      state = week(Date.now());
      var h = handles(state.idx);
      return Promise.all([gift(h.current), gift(h.second)]).then(function (pair) {
        var g = { current: pair[0], second: pair[1] };
        fill(g);
        showTimer(!!g.current);
        tick();
        return fixCart(g);
      });
    }
    load();
    setInterval(function () { if (timerOn || Date.now() >= state.end) { tick(); } }, 1000);
  })();
})();
